/* eslint-disable lines-between-class-members,dot-notation,import/no-cycle */
import BaseModel from '@kakadu-dev/base-frontend-helpers/models/BaseModel';
import { Order } from "./Order";
import { paymentStatuses, paymentStatusesTypes } from "./statuses";
/**
 * Order payment class
 */

export class OrderPayment extends BaseModel {
  constructor(...args) {
    super(...args);

    this.getOrderId = () => {
      return this.model.orderId;
    };

    this.getOfferId = () => {
      return this.model.transactionId;
    };

    this.getStatus = (asLabel = false) => {
      return asLabel ? OrderPayment.statuses[this.model.status || 'unknown'] || OrderPayment.statuses['unknown'] : this.model.status;
    };

    this.getCreatedAt = () => {
      return this.model.createdAt;
    };

    this.getUpdatedAt = () => {
      return this.model.updatedAt;
    };

    this.getOrder = order => {
      return this.getRelation('order', Order, order);
    };
  }

  /**
   * Create order payment
   *
   * @param {object} object
   *
   * @return {OrderPayment}
   */
  static create(object) {
    return super.create(object);
  }
  /**
   * Create list order payments
   *
   * @param {object} objects
   *
   * @return {Array.<OrderPayment>}
   */


  static createList(objects) {
    return super.createList(objects);
  }
  /**
   * Map order payments
   *
   * @param {Array.<object>} objects
   * @param {function(OrderPayment): undefined} callback
   *
   * @return {Array.<object>}
   */


  static map(objects, callback) {
    return super.map(objects, callback);
  }
  /**
   * Get order id
   *
   * @return {number}
   */


}
OrderPayment.statusesTypes = paymentStatusesTypes;
OrderPayment.statuses = paymentStatuses;